import './SearchInputBox.css';
import React from 'react';
import { IconClosePrimary } from '../../../../atoms/Icons';
export var SearchInputBox = function SearchInputBox(_ref) {
  var placeholder = _ref.placeholder,
    rtl = _ref.rtl,
    handleInputChange = _ref.handleInputChange,
    query = _ref.query,
    clearSearch = _ref.clearSearch;
  return /*#__PURE__*/React.createElement(StyledContainer, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "search-box-wrapper "
  }, /*#__PURE__*/React.createElement("div", {
    className: "search search-page"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: placeholder,
    value: query,
    onChange: function onChange(e) {
      return handleInputChange(e);
    }
  }), !query ? /*#__PURE__*/React.createElement("div", {
    className: "icon-search"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19.628",
    height: "19.628",
    viewBox: "0 0 19.628 19.628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_36",
    "data-name": "Union 36",
    d: "M13.23,13.23A7.75,7.75,0,1,1,15.5,7.75a7.726,7.726,0,0,1-2.27,5.48l4.52,4.52Z",
    transform: "translate(1.1 1.1)",
    fill: "none",
    stroke: "var(--m113-interactive-map-background-color)",
    "stroke-width": "2.2"
  }))) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "reset-btn",
    onClick: clearSearch
  }, /*#__PURE__*/React.createElement(IconClosePrimary, null)))));
};
var StyledContainer = function StyledContainer(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1n8eb33";
var ltrStyles = "lzbcvlo";
var rtlStyles = "r13dh1kt";